/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import moment from "moment";

const getStyles = value => {
  const styles = {
    color: "LIMEGREEN",
    fontWeight: "bolder"
  };

  if (value <= 0) {
    styles.color = "CRIMSON";
  } else if (value <= 30) {
    styles.color = "ORANGERED";
  } else if (value <= 45) {
    styles.color = "ORANGE";
  } else if (value <= 60) {
    styles.color = "YELLOW";
  }
  return styles;
};

export const EMPLOYEE_CERTIFICATION_COLUMNS = [
  {
    Header: "Type",
    accessor: "Type.CodeDescription",
    id: "CertificationName"
  },
  {
    Header: "Last Test Date",
    accessor: "LastTestDate",
    id: "LastTestDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YY") : ""
  },
  {
    Header: "Expiration Date",
    accessor: "ExpirationDate",
    id: "ExpirationDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YY") : ""
  },
  {
    Header: "Days To Expire",
    accessor: "DaysToExpire",
    id: "DaysToExpire",
    Cell: ({ cell }) => <span style={getStyles(cell.value)}>{cell.value}</span>
  }
];
